"use client";

import { AnimatePresence } from "motion/react";
import type { ReactNode } from "react";

export const AnimationProvider = ({
	children,
	...props
}: {
	children: ReactNode;
	props?: any;
}) => {
	return (
		<AnimatePresence {...props} mode="wait">
			{children}
		</AnimatePresence>
	);
};
